(function () {
    'use strict';

    angular
        .module('ib-checkin-services-module')
        .service('CallAcceptService', CallAcceptService);

    CallAcceptService.$inject = ['FlightsPassengersUtils', 'UtilsService', 'localStorageService', 'AcceptObjectsPolicyService', 'ModalService', '$location', 'GetCKICachedInformationService', 'CheckAncillariesService', 'CheckPaymentsService', '$route', 'CheckinAppConstants', 'CkiDatalayerConstants', 'FlightsPassengersService', 'CommonsAncillariesService'];
    function CallAcceptService (FlightsPassengersUtils, UtilsService, localStorageService, AcceptObjectsPolicyService, ModalService, $location, GetCKICachedInformationService, CheckAncillariesService, CheckPaymentsService, $route, CheckinAppConstants, CkiDatalayerConstants, FlightsPassengersService, CommonsAncillariesService) {

        const self = this;
        self.callAccept = callAccept;
        self.nextViewAfterAccept = nextViewAfterAccept;

        /**
         * @function
        * @name callAccept
        * @desc calls accepted forbidden objects policy and continue to the next step
        */
        function callAccept (passengers, printBoardingCard, nextStep, isEarly) {
            const requestAcceptInfo = FlightsPassengersUtils.getAcceptUpdateInformation(localStorageService.get('availableSegments'), passengers);
            let modalObject;

            AcceptObjectsPolicyService.acceptForbiddenObjectsPolicy(requestAcceptInfo).then(acceptPolicySuccess, acceptPolicyError);

            function acceptPolicySuccess (acceptInfo) {
                const uncheckableSegments = UtilsService.updateCachedInfo(acceptInfo.data.acceptedSegments);
                let acceptedSegments = acceptInfo?.data?.acceptedSegments || [];
                const seatsAssigned = checkAcceptSeats();

                ModalService.isNotWaiting();
                if (uncheckableSegments.length > 0) {
                    acceptedSegments = FlightsPassengersUtils.updateSelectedSegments(localStorageService.get('availableSegments'), uncheckableSegments);
                    localStorageService.set('availableSegments', acceptedSegments);
                    ModalService.showGenericError({ message: 'NOT_ACCEPTED_SEGMENT_ERROR', needsTranslate: true, idModal: CkiDatalayerConstants.DATALAYER_MODAL_ID.NOT_ACCEPTED_SEGMENT_ERROR }, true, 'apis.error-modal.html').result.then(acceptSegmentsError, acceptSegmentsError);
                } else {
                    if (isEarly) {
                        FlightsPassengersService.checkAvailabilitySeatsPassengers().then((response) => {
                            if (response || seatsAssigned) {
                                ModalService.isNotWaiting();
                                checkAcceptResponse();
                            } else {
                                seatNotAvailableError();
                            }
                        }, () => {
                            ModalService.showGenericError().result.then(UtilsService.goIbCose, UtilsService.goIbCose);
                        });

                    } else {
                        checkAcceptResponse();
                    }
                }

                function checkAcceptSeats () {
                    let seatsAssigned = true;
                    acceptedSegments.forEach(segment => {
                        segment.passengers.forEach(passenger => {
                            if (passenger.seat === null)
                                seatsAssigned = false;
                        });
                    });
                    return seatsAssigned;
                }

                function acceptSegmentsError () {
                    if (acceptedSegments.length > 0) {
                        checkAcceptResponse();
                    } else {
                        UtilsService.goIbCose();
                    }
                }

                function checkAcceptResponse () {
                    ModalService.isWaiting();
                    if ((acceptInfo.code === 201 || acceptInfo.code === 200) && acceptInfo.data.locator != null) {
                        GetCKICachedInformationService.getCachedInformation().then(function (cachedData) {
                            localStorageService.set('bookingInfo', cachedData);
                            localStorageService.set('passengersSelected', FlightsPassengersUtils.updateSelectedPassengers(localStorageService.get('passengersSelected'), cachedData.passengers));
                            ModalService.isNotWaiting();
                            ModalService.openSplitModal('md', 'modal-split', false, acceptInfo.data.locator).result.then(startCheckinFromSplit, startCheckinFromSplit);
                        }, function (error) {
                            ModalService.showGenericError(error, false);
                        });
                    } else {
                        nextViewAfterAccept(printBoardingCard, nextStep, acceptInfo);
                    }

                    function startCheckinFromSplit () {
                        $location.path('/ibcose').search({ surname: localStorageService.get('checkinSurname'), pnr: response.data.locator });
                    }
                }
            }

            function acceptPolicyError (error) {
                ModalService.finishWaiting();
                ModalService.showGenericError(error, false).result.then(updateCachedData, updateCachedData);

                function updateCachedData () {
                    if (error.internalErrorCode !== 'IB_00002') {
                        GetCKICachedInformationService.getCachedInformation().then(function (data) {
                            localStorageService.set('bookingInfo', data);
                            goToIbcoac();
                        }, function (error) {
                            goToIbcoac();
                        });
                    }

                    function goToIbcoac () {
                        if ($location.path() === '/ibcoac') {
                            $route.reload();
                        } else {
                            $location.path('/ibcoac');
                        }
                    }
                }
            }
        }


        function nextViewAfterAccept (printBoardingCard, nextStep, response) {
            if(localStorageService.get('bookingInfo')?.ancillariesDisabled) $location.path('/ibecbp');
            else if(response.code===202) {
                ModalService.showGenericModal({ message: '{{\'ALERT_NO_SHOW_FEES\'|translate}}'}, true, 'generic-info-modal').result.then(function () {
                    checkAncillaries(printBoardingCard, nextStep, response.data);
                }, () => {
                    checkAncillaries(printBoardingCard, nextStep, response.data);
                });
            } else{
                checkAncillaries(printBoardingCard, nextStep, response.data);
            }
        }


        /**
         * Call ancillaries service
         * @param {BOOL} printBoardingCard
         * @param {String} nextStep Next step in flow
         * @param {Object} responseData
         */
        function checkAncillaries (printBoardingCard, nextStep, responseData) {
            const pendingPayments = localStorageService.get('pendingPayments'), pnr = localStorageService.get('PNR');
            const isEarly = localStorageService.get('isEarly');
            localStorageService.set('acceptInfoSegments', responseData);

            if (printBoardingCard) {
                if (pendingPayments) {
                    CheckPaymentsService.checkPayments();
                } else {
                    CommonsAncillariesService.getAncillarieSummary(undefined, null, pnr).then(
                        (ancillariesSummary) => {
                            localStorageService.set('summaryInfo', ancillariesSummary);
                            $location.path('/ibecbp');
                        },
                        serviceError()
                        /*
                         * Code commented out due to the recurring HTTP 500 response from the ancillaries-summary service.
                         * JIRA Task: DIB-9322
                         *
                         * () => {
                         *     ModalService.showGenericError({ message: 'REST_SERVICE_ERROR_GENERAL', needsTranslate: true }, true).result.then(() => {
                         *         UtilsService.goIbCose();
                         *     }, () => {
                         *         UtilsService.goIbCose();
                         *     });
                         * }
                         */
                    );
                }
            } else if (responseData && responseData.upgrading) {
                localStorageService.set('upgradeInfo', responseData.upgrading);
                $location.path('/ckiancupp');
            } else {
                const pnr = localStorageService.get('PNR');
                CommonsAncillariesService.getAncillarieSummary(undefined, null, pnr).then(CommonsAncillariesServiceSucces, CommonsAncillariesServiceError);
            }

            function CommonsAncillariesServiceSucces (ancillariesSummary) {
                UtilsService.setAncillariesCurrency(ancillariesSummary.currencies, ancillariesSummary.context.issueCurrency);
                UtilsService.setAncillariesBob(ancillariesSummary.freeItems);
                CheckAncillariesService.checkAncillaries().then(() => continueFlow(ancillariesSummary), serviceError);
            }

            function CommonsAncillariesServiceError (response) {
                const acceptInfo = localStorageService.get('acceptInfoSegments');
                let uncheckableSegments = false;
                angular.forEach(acceptInfo.acceptedSegments, (segments) => {
                    angular.forEach(segments.passengers, (pax) => {
                        if(pax.status === 'CHECKED' && pax.seat === null && pax.purchaseSeatRequired) {
                            uncheckableSegments = true;
                        }
                    });
                });

                if(uncheckableSegments) {
                    ModalService.showGenericError({ message: 'REST_SERVICE_ERROR_GENERAL', needsTranslate: true }, true).result.then(() => {
                        UtilsService.goIbCose();
                    }, () => {
                        UtilsService.goIbCose();
                    });
                } else {
                    serviceError();
                }
            }

            function continueFlow (ancillariesSummary) {
                if (nextStep === CheckinAppConstants.SHUTTLE_NEXT_STEPS.SEATS_MAP) {
                    localStorageService.set('seatMapSegment', { segmentId: Number(localStorageService.get('availableSegments')[0]), pasId: localStorageService.get('passengersSelected')[0] });
                    if(ancillariesSummary && ancillariesSummary.context && ancillariesSummary.context.segments.length > 0 && ancillariesSummary.context.segments[0].passengerCoupons[0].status.code === CheckinAppConstants.FLIGHT_PASSENGERS_STATUS.STANDBY) {
                        localStorageService.set('isPaFlow', false);
                    } else {
                        localStorageService.set('isPaFlow', true);
                    }

                    $location.path('/ckianc');

                } else {
                    ModalService.isNotWaiting();
                    $location.path('/ckianc');
                }
            }

            /**
             * Redirect user to payments or boarding-document depending if have
             * pending payments
             */
            function serviceError () {
                ModalService.isNotWaiting();
                if (pendingPayments) {
                    $location.path('/ibpurc');
                } else {
                    $location.path('/ibecbp');
                }
            }
        }
        function seatNotAvailableError () {
            ModalService.isNotWaiting();
            const modalObject = {
                title: {
                    message: 'CKIANCPURC_MODAL_TARJ_TITLE',
                    needsTranslate: true
                },
                needsTranslate: true,
                message: 'MODAL_UNAVAILABLE_SEATMAP',
                idModal: 'MOD_INFO_TITLE'
            };
            ModalService.showGenericModal(modalObject, true).result.then(UtilsService.goIbCose, UtilsService.goIbCose);
        }

    }
})();
